module.exports = __webpack_public_path__ + "static/media/IdGenerator.6ddcc8c3.svg";